var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('alert-box',{staticClass:"mt-2",attrs:{"msg":_vm.msg},on:{"close":function($event){_vm.msg.title=''}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }